import React, { useEffect } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
  PasswordTextInputBase,
  CheckboxBase,
} from "@reusejs/react";
import GoogleSvg from "../../Icons/GoogleSvg";
import {
  login,
  getUser,
  initiateGoogleLogin,
  requestVerification,
  getSubscriptionByUserUuid,
  checkAndUpdateBidder,
} from "services";
import {
  setTokens,
  setUser,
  webStore,
  setGuestUser,
  setSubscription,
} from "store";

export default function LoginForm(props: any) {
  const form = useBetaForm({
    email: "",
    password: "",
    remember_me: true,
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    password: {
      presence: {
        allowEmpty: false,
      },
      length: {
        minimum: 8,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        const data: any = await login(form);
        const res = await fetch("/api/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ accessToken: data }),
        });
        const resData = await res.json();

        webStore.dispatch(setTokens(data));

        const user: any = await getUser();

        webStore.dispatch(setUser(user));

        const subscription = await getSubscriptionByUserUuid(user.uuid);
        const validateBidderEmail = await checkAndUpdateBidder(
          user?.attributes[0]?.value,
          user.uuid
        );

        if (subscription) {
          webStore.dispatch(setSubscription(subscription));
        }

        if (props.onAction) {
          props.onAction("no");
        }

        if (webStore.getState().auth.redirectUrl) {
          props.router.push(webStore.getState().auth.redirectUrl);
        } else {
          props.router.push("/");
        }
      }
    } catch (error: any) {
      console.log("check here error", error);
      if (error && error?.message === "AttributeNotVerified") {
        await requestVerification(form);
        webStore.dispatch(setGuestUser({ guestUser: form.value }));
        props.router.push("/verify");
      }
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const data: any = await initiateGoogleLogin();
      props.router.push(data.redirect_to);
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <div className="mt-6 space-y-4">
      <div className="">
        <TextInputBase
          labelBaseProps={{
            label: "Email*",
          }}
          name={"email"}
          onChange={(val) => form.setField("email", val)}
          placeholder={"Enter your email"}
          type={"text"}
          error={
            form.errors.get("email") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("email")[0]}
              </p>
            ) : null
          }
          value={form.getField("email")}
          htmlFor={"email"}
        />
      </div>

      <div className="space-y-1">
        <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700"
        >
          Password
        </label>
        <div className="mt-1">
          <PasswordTextInputBase
            htmlFor={"password"}
            name="password"
            onChange={(val) => form.setField("password", val)}
            type="password"
            value={form.getField("password")}
            placeholder="Password"
            error={
              form.errors.get("password") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("password")[0]}
                </p>
              ) : null
            }
          />
        </div>
      </div>

      <div className="flex justify-between items-center">
        <CheckboxBase
          labelBaseProps={{
            label: "Remember me for 30 days",
          }}
          htmlFor="remember"
          name="remember"
          type="text"
          value={form.getField("remember_me")}
          onChange={() =>
            form.setField("remember_me", !form.getField("remember_me"))
          }
          checkboxBaseClasses={{
            textColor: "text-blue-700",
          }}
        />

        <div className="text-base md:text-sm">
          <a
            href="/forgotpassword"
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            Forgot password
          </a>
        </div>
      </div>

      <div className="flex flex-col space-y-4">
        <ButtonBase
          variant="primary"
          label="Sign in"
          onClick={handleSubmit}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />

        <ButtonBase
          variant="primary"
          buttonPrefix={
            <div className="mr-2">
              <GoogleSvg width="24" height="24" />
            </div>
          }
          label="Sign in with Google"
          onClick={() => {
            handleGoogleLogin();
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-white",
            textColor: "text-black",
            border: "border border-gray border hover:border-blue-700",
            width: "w-full",
          }}
        />

        <div className="mt-4 text-sm text-center">
          Don’t have an account?{" "}
          <a
            href="/signup"
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            Sign up
          </a>
        </div>
      </div>
    </div>
  );
}
